import $ from "jquery";

let loadedOpts = "";

export function createMapsAPI(opts) {
  function load (mapOpts, callback) {
    const key = JSON.stringify(mapOpts);
    if(loadedOpts) {
      if (loadedOpts !== key) {
        console.warn("Maps: trying to reinitialize with different options: " + key);
      }
      callback();
      return;
    }
    loadedOpts = key;

    window.onMapAPILoad = function() {
      delete window.onMapAPILoad;
      callback();
    };

    const overrides = {
      callback: "onMapAPILoad",
      language: opts.language || "en",
      key: opts.key
    };

    mapOpts = Object.assign(mapOpts || {}, overrides);

    const optionsQuery = $.param(mapOpts);

    const url = "https://maps.googleapis.com/maps/api/js?" + optionsQuery;

    const script = document.createElement('script');

    script.setAttribute('src', url);
    script.setAttribute('async', '');
    script.setAttribute('defer', '');

    document.head.appendChild(script);
  }

  return {
    load
  };
}
